exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qtd_product[readonly][data-v-00acb038]{background:#fff;opacity:.7}", ""]);

// exports
